'use client';

import React from 'react';
import { Locale, switchLanguage } from '../ssv-metting/i18n/config';

interface LanguageSwitchButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  targetLang: Locale;
}

export function LanguageSwitchButton({
  targetLang,
  onClick,
  type = 'button',
  ...rest
}: LanguageSwitchButtonProps) {
  return (
    <button
      {...rest}
      type={type}
      onClick={(event) => {
        onClick?.(event);
        if (event.defaultPrevented) {
          return;
        }
        switchLanguage(targetLang);
      }}
    />
  );
}
